// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_93ae07d","iconWrapperRegistered":"_fa2b6df"};